var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchantOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29009 0.227609L4.52795 1.59958L7.69057 14.0524C7.69057 14.0524 7.19608 14.0828 6.89992 14.1842C6.59488 14.2886 6.30693 14.316 6.30693 14.316L3.34197 2.65379L0.729464 1.55654C0.355677 1.39955 0.184704 0.965395 0.351073 0.595687C0.511974 0.238128 0.92907 0.0746339 1.29009 0.227609ZM11.5121 16.1608L19.8938 14.0958C20.2892 13.9984 20.6901 14.2341 20.7972 14.6269C20.9083 15.0342 20.6617 15.4529 20.2516 15.5532L11.8415 17.6104C11.8415 17.6104 11.8232 17.1646 11.7756 16.8856C11.725 16.5887 11.5121 16.1608 11.5121 16.1608Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08587 20.9048C9.79615 20.9048 11.1826 19.5183 11.1826 17.808C11.1826 16.0978 9.79615 14.7113 8.08587 14.7113C6.37559 14.7113 4.98914 16.0978 4.98914 17.808C4.98914 19.5183 6.37559 20.9048 8.08587 20.9048ZM8.08586 19.7847C9.17753 19.7847 10.0625 18.8997 10.0625 17.808C10.0625 16.7164 9.17753 15.8314 8.08586 15.8314C6.99419 15.8314 6.10922 16.7164 6.10922 17.808C6.10922 18.8997 6.99419 19.7847 8.08586 19.7847Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78821 6.0283L16.1534 3.58263C16.6923 3.44189 17.2423 3.7686 17.3765 4.30918L19.5705 13.1442L11.598 15.1867C11.598 15.1867 11.0709 14.5279 10.3462 14.0666C9.62139 13.6054 8.69896 13.6054 8.69896 13.6054L6.78821 6.0283ZM8.50129 6.95074L16.0125 5.03998L17.9233 12.0241L12.0592 13.6054C12.0592 13.6054 11.6347 13.3272 11.149 12.9941C10.6634 12.661 9.95083 12.6171 9.95083 12.6171L8.50129 6.95074Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantOrderIcon);
export default __webpack_public_path__ + "static/media/merchant_order_icon.9a3dcaca449ba61fe54f0352f21edcbf.svg";
export { ForwardRef as ReactComponent };